import { useIntl } from "react-intl";

import FormItem from "forms/fields/FormItem";
import type { FormControlType } from "types/formType";
import type { IFormInputs } from "types/uiSchema";
import { Select as BaseSelect } from "ui/Select/Select";
import { FormField } from "uiShadcn/form";

export interface SelectProps {
    control: FormControlType;
    uiData: IFormInputs;
}

export default function Select({ control, uiData }: SelectProps) {
    const { formatMessage } = useIntl();
    const name = uiData["x-json-schema-reference-property"];
    const isRequired = uiData?.required?.includes("true");

    const dictionary = uiData["x-dictionary"] ?? [];

    if (!name || dictionary?.length === 0) return null;

    return (
        <FormField
            control={control}
            name={name}
            render={({ field }) => (
                <FormItem label={uiData.description} required={isRequired}>
                    <BaseSelect
                        ref={field.ref}
                        dataTestId={`Select-${field.name}`}
                        defaultValue={field.value}
                        onValueChange={field.onChange}
                        required={isRequired}
                        options={dictionary}
                        placeholder={formatMessage({ id: "select" })}
                    />
                </FormItem>
            )}
        />
    );
}
